<script>
import { useFormValidation } from '../../composables/useFormValidation'
import EcErrorBanner from '../ui/EcErrorBanner.vue'
import EcCheckbox from '../ui/EcCheckbox.vue'
import EcInput from '../ui/EcInput.vue'

export default {
  name: 'ModuleCredentialForm',
  components: { EcErrorBanner, EcCheckbox, EcInput },

  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },

  props: {
    modelValue: { type: Object, default: () => ({}) },
    serviceType: { type: String, default: '' },
    title: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    fields: { type: Array, default: () => [] },
    formErrors: { type: Object, default: null },
  },
  data() {
    const { apiGlobalErrors, apiRawError, setApiValidation, resetApiValidation } = useFormValidation()
    return {
      apiGlobalErrors,
      apiRawError,
      setApiValidation,
      resetApiValidation,
      config: this.modelValue || {},
      iconForType: {
        password: 'key',
        url: 'link-45deg',
        email: 'envelope',
      },
    }
  },
  computed: {
    isDisabled() {
      return this.disabled ?? false
    },
  },
  watch: {
    modelValue: {
      handler(newVal) {
        this.config = newVal ?? {}
      },
      deep: true,
    },
    config: {
      handler(newVal) {
        this.$emit('update:modelValue', newVal)
      },
      deep: true,
    },
    formErrors(errors) {
      if (errors) this.setApiValidation(errors)
      else this.resetApiValidation()
    },
  },
}
</script>

<template>
  <div v-if="serviceType" class="ec-config-form">
    <EcErrorBanner :error="apiRawError ?? apiGlobalErrors" class="ec-mb-3" />

    <div v-for="field in fields" :key="field.key" class="ec-config-form__field">
      <!-- Boolean field -->
      <EcCheckbox
        v-if="field.type === 'boolean'"
        v-model="config[field.key]"
        :label="field.label"
        :description="field.description"
        :disabled="isDisabled"
      />

      <!-- Textarea -->
      <div v-else-if="field.type === 'textarea'" class="ec-form-group">
        <label class="ec-form-label">{{ field.label }}</label>
        <textarea
          v-model="config[field.key]"
          class="ec-textarea"
          :disabled="isDisabled"
          :placeholder="field.label"
          rows="4"
        />
        <small v-if="field.description" class="ec-form-hint">{{ field.description }}</small>
      </div>

      <!-- Standard input -->
      <template v-else>
        <EcInput
          v-model="config[field.key]"
          :type="field.type"
          :label="field.label"
          :disabled="isDisabled"
          :placeholder="field.label"
          :icon="iconForType[field.type]"
          :hint="field.description"
        />
      </template>
    </div>
  </div>
</template>
